import { G2S } from '../g2s';
import * as api from '../api';
import moment from 'moment';

class RetailRocketIds {
    sessionId: string;
    flightKey: string;
    constructor() {
        const sessionId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
        
        if (window.localStorage) {
            if (window.localStorage['rrApiKey']) {
                this.sessionId = window.localStorage['rrApiKey'];
            } else {
                window.localStorage['rrApiKey'] = sessionId;
                this.sessionId = sessionId;
            }
        }
    }

    get getFlightKey() {
        return this.flightKey;
    }

    get getSessionId() {
        return this.sessionId;
    }

    setFlightKey(flightKey: any) {
        this.flightKey = flightKey;
    }
}

export const RetailRocketCL = new RetailRocketIds();

export class RetailRocket {
    concatRequest(request: any, addFlightKey?: boolean) {
        if (addFlightKey && RetailRocketCL.flightKey) {
            request.flightKey = RetailRocketCL.flightKey;
        }
        return {
            ...request,
            sessionId: RetailRocketCL.sessionId,
            timestamp: moment().format()
        };
    }

    userAuthenticated(request: api.RRUserAuthenticated): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Tracking/UserAuthenticated',
                    {
                        ...this.concatRequest(request)
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    flightDetailsOpened(request: api.RRFlightDetailsOpened): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Tracking/FlightDetailsOpened',
                    {
                        ...this.concatRequest(request)
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    console.log(RetailRocketCL.setFlightKey);
                    
                    RetailRocketCL.setFlightKey(response.data);
                    
                    resolve(<string>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    orderFormOpened(request: api.RROrderFormOpened): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Tracking/OrderFormOpened',
                    {
                        ...this.concatRequest(request)
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    RetailRocketCL.setFlightKey(response.data);

                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    orderFormStepOpened(request: api.RROrderFormStepOpened): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Tracking/OrderFormStepOpened',
                    {
                        ...this.concatRequest(request, true)
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    RetailRocketCL.setFlightKey(response.data);

                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    productSelected(request: api.RRProductSelected): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Tracking/ProductSelected',
                    {
                        ...this.concatRequest(request, true)
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    reservationCreated(request: api.RRReservationCreated): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Tracking/ReservationCreated',
                    {
                        ...this.concatRequest(request, true)
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    searchCompleted(request: api.RRSearchCompleted): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Tracking/SearchCompleted',
                    {
                        ...this.concatRequest(request, true)
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
}
